import { render } from "./PanelPlants.vue?vue&type=template&id=0524ba84"
import script from "./PanelPlants.vue?vue&type=script&lang=js"
export * from "./PanelPlants.vue?vue&type=script&lang=js"

import "./PanelPlants.vue?vue&type=style&index=0&id=0524ba84&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__